import React, { Component } from 'react'
 import Select from 'react-select';
import { AUTHOR_IMAGE } from '../../../../../utils';

export default class AccountSelect extends Component {

    state = {selectedOption:null , allOptions:[] };
     
     componentDidMount(){
         const {feed} = this.props 
         var option=[], fontDefault 

         feed && feed.accountList && feed.accountList.length && feed.accountList.map((account, index)=>{
            if (account.id == feed.connectedAccount) {
                fontDefault = { value: account.id, label: (<span  className="filter-option pull-left d-flex align-items-center" key={account.id}><div  className="symbol symbol-30 random_color-2 symbol-circle me-2 selectAcc"style={{ backgroundImage: `url(${account.profilePicture.replace(/\s/g, '')}),url(${AUTHOR_IMAGE(account.accountName, account.color)})`,width:'30px',height:"30px",backgroundSize:'cover' }}></div>{account.accountName}</span>) }
              }

              option.push({ value: account.id, label: (<span  className="filter-option pull-left d-flex align-items-center"  key={index}><div  className="symbol symbol-30 random_color-2 symbol-circle me-2 selectAcc"style={{ backgroundImage: `url(${account.profilePicture.replace(/\s/g, '')}),url(${AUTHOR_IMAGE(account.accountName, account.color)})`,width:'30px',height:"30px",backgroundSize:'cover' }}></div>{account.accountName}</span>) })
         }) 
        this.setState({allOptions:option, selectedOption:fontDefault})
     }

    



    handleChange = (e) => {
        const { feed , changeAccount} = this.props
        if(![34, 25, 66].includes(feed.filterId)) changeAccount(e.value, feed.id);
    }






    render() {
        const { selectedOption, allOptions } = this.state; 
        const { feed } = this.props; 
        const isDisable = feed.networkId==2 && [1, 25, 34, 66].includes(feed.filterId) ? true : false;
        
        return ( allOptions && allOptions.length && selectedOption && selectedOption.value ? 
        <Select  isSearchable={false} menuPlacement="auto" classNamePrefix="selectpicker" className="selectedOptionData" defaultValue={selectedOption} onChange={(e)=>this.handleChange(e)}  options={allOptions}  isDisabled={isDisable} /> :'--')
    }
}
